import Head from "next/head";
import React from "react";

function ProductSchema({ name, brand, imageURL, colour, size, price }) {
  const formattedPrice = parseFloat(price).toFixed(2);
  const formattedName = `${brand.name} - ${name}`;

  let schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: formattedName,
    brand: brand.name,
    color: colour,
    size: size,
    offers: {
      "@type": "Offer",
      availability: "https://schema.org/InStock",
      price: formattedPrice,
      priceCurrency: "GBP",
    },
  };

  if (imageURL) {
    schema.image = imageURL;
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema),
        }}
      />
    </Head>
  );
}

export default ProductSchema;
